import React from 'react';
import { Dialog, DialogContent, DialogTitle, Typography } from '@mui/material';
import dayjs from 'dayjs';

import { MIT } from '../../../../store/modules/mit/types';
import { MITDetails, MITDetailsPage } from './index';
import { DialogCloseButton } from '../../../../components/core/DialogCloseButton';

interface Props {
  merchantId: string;
  mit: MIT;
  isOpen: boolean;
  onClose: () => void;
  defaultOpenPage?: MITDetailsPage;
}

const DetailModal = ({ isOpen, onClose, mit, merchantId, defaultOpenPage }: Props) => {
  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      PaperProps={{ sx: { borderRadius: 4, overflow: 'hidden' } }}
    >
      <DialogTitle
        sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 1, alignItems: 'center' }}
      >
        <Typography sx={{ fontSize: '16px', fontWeight: 600, color: 'black' }}>Details</Typography>
        <Typography
          sx={{
            fontSize: 12,
            color: 'grey.600',

            textAlign: 'center',
            whiteSpace: 'nowrap',
          }}
        >
          {dayjs(mit.createdAt).format('M/D/YY h:mma')}
        </Typography>
      </DialogTitle>
      <DialogCloseButton onClose={onClose} />
      <DialogContent sx={{ p: 0, overflowX: 'hidden', minHeight: '600px' }} dividers>
        <MITDetails merchantId={merchantId} mit={mit} defaultOpenPage={defaultOpenPage} />
      </DialogContent>
    </Dialog>
  );
};

export default DetailModal;
